import { Tooltip, TooltipContent, TooltipTrigger } from '@leadsnavi/ui-kit';
import { ReactNode } from 'react';

export const BaseTooltip = ({ children, content }: { children: ReactNode; content: ReactNode }) => {
  return (
    <Tooltip open={content ? undefined : false}>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent className="max-w-[315px]  py-1.5 px-2 ">
        <p className="break-words overflow-auto max-h-[400px]">{content}</p>
      </TooltipContent>
    </Tooltip>
  );
};
